export const ROLES = {
  SYSADMIN: "system_admin",
  PARKING_ADMIN: "parking_zone_admin",
  PARKING_OWNER: "parking_zone_owner",
  PARKING_MANAGER: "parking_zone_manager",
  VISITOR: "visitor",
  GAS_STATION_ADMIN: "gas_station_admin",
  GAS_STATION_MANAGER: "gas_station_manager",
  PARKING_VIEWER: "parking_zone_viewer",
  GAS_STATION_VIEWER: "gas_station_viewer"
};

export const zurichMarker = {
  center: {
    lat: 47.373878,
    lng: 8.545094,
  },
  zoom: 11,
};

export const berlinMarker = {
  center: {
    lat: 52.521992,
    lng: 13.413244,
  },
  zoom: 11,
};

export const viennaMarker = {
  center: {
    lat: 48.210033,
    lng: 16.363449,
  },
  zoom: 11,
};

export const defaultMarker = zurichMarker;

export const manualParkingZoneMarkerEnabled = false;

export const ADDRESS_GEOCODING_DELAY = 1300;

export const aralFuelTypes = {
  "ADBLUE": "ADBLUE",
  "ERDGAS": "ERDGAS",
  "CNG": "CNG",
  "DIESEL": "DIESEL",
  "LKW - DIESEL": "LKW - DIESEL",
  "SUPER E10": "SUPER E10",
  "SUPER E5": "SUPER E5",
  "SUPERPLUS": "SUPERPLUS",
  "ULTIMATE 102": "ULTIMATE 102",
  "ULTIMATE DIESEL": "ULTIMATE DIESEL",
  "LPG": "LPG",
  "ARAL HVO": "ARAL HVO",
  "FUTURA SUPER 95": "FUTURA SUPER 95",
  "FUTURA DIESEL": "FUTURA DIESEL"
};

export const DebtNoteType = {
  BEPPO: "BEPPO",
  GAS_STATION: "GAS_STATION"
};

export const defaultAustrianPricingStructure = {
  fuelTypes: [
    {
      maxFuelValue: 19,
      processingFeeFlat: 13.50,
      processingFeePercentage: 0,
      reminderFee: 6.50,
      lastReminderFee: 9.00,
      addressSurchargeWithinMunicipality: 9.00,
      addressSurchargeOutsideMunicipality: 9.00,
      addressSurchargeAbroad: 75.00
    },
    {
      maxFuelValue: 30,
      processingFeeFlat: 13.50,
      processingFeePercentage: 0,
      reminderFee: 9.50,
      lastReminderFee: 15.50,
      addressSurchargeWithinMunicipality: 19.00,
      addressSurchargeOutsideMunicipality: 19.00,
      addressSurchargeAbroad: 75.00
    },
    {
      maxFuelValue: 73,
      processingFeeFlat: 22.50,
      processingFeePercentage: 0,
      reminderFee: 9.50,
      lastReminderFee: 15.50,
      addressSurchargeWithinMunicipality: 29.00,
      addressSurchargeOutsideMunicipality: 29.00,
      addressSurchargeAbroad: 75.00
    },
    {
      maxFuelValue: 364,
      processingFeeFlat: 0.00,
      processingFeePercentage: 22,
      reminderFee: 17.50,
      lastReminderFee: 25.50,
      addressSurchargeWithinMunicipality: 29.00,
      addressSurchargeOutsideMunicipality: 49.00,
      addressSurchargeAbroad: 75.00
    },
    {
      maxFuelValue: 727,
      processingFeeFlat: 0.00,
      processingFeePercentage: 17,
      reminderFee: 27.50,
      lastReminderFee: 35.50,
      addressSurchargeWithinMunicipality: 29.00,
      addressSurchargeOutsideMunicipality: 49.00,
      addressSurchargeAbroad: 75.00
    },
    {
      maxFuelValue: 100000,
      processingFeeFlat: 0.00,
      processingFeePercentage: 8,
      reminderFee: 77.50,
      lastReminderFee: 85.50,
      addressSurchargeWithinMunicipality: 29.00,
      addressSurchargeOutsideMunicipality: 49.00,
      addressSurchargeAbroad: 75.00
    }
  ]
};